export enum COMPANIES {
  SINGER_DEV = 3246,
  SINGER_PROD = 3177,
  MIDDLEBY_DEV = 3236,
  MIDDLEBY_PROD = 3263,
  PJP_DEV = 3146,
  PJP_PROD = 3161,
  SYSCO_DEV = 3248,
  SYSCO_PROD = 3417,
  TELABIO_DEV = 3119,
  TELABIO_PROD = 3401,
  CSF_BRANDS_DEV = 3250,
  ELANCO_PROD = 3423,
  IPACK_PROD = 3425,
  IWECK_DEV = 3255,
  FRANLINK_DEV = 3256,
  BOELTER_DEV = 3257,
  BOELTER_PROD = 3428,
  FRANLINK_PROD = 3375
}

export enum COMPANIES_NAMES {
  MIDDLEBY = 'Middleby Commercial'
}
